module.exports = __webpack_public_path__ + "static/img/whatwedo-horizontal.22877924.jpg";